<template>
  <div class="ws-data-table-pagenate">
    <WsPagenateTypeA
      @pageto="$_onPageto($event)"
      :currentPage="currentPage"
      :lastPage="lastPage"
    ></WsPagenateTypeA>
  </div>
</template>

<script>
export default {
  props: {
    currentPage: [Number, String],
    lastPage: Number
  },
  methods: {
    $_onPageto($event) {
      this.$emit("pageto", $event);
    }
  }
};
</script>

<style>
</style>